import { css } from '@leafygreen-ui/emotion';
import { fontWeights } from '@leafygreen-ui/tokens';

export const overlineStyles = css`
  font-size: 12px;
  font-weight: ${fontWeights.bold};
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`;
